import { useContext, useEffect, useState } from "react";
import { AdminContext } from "../../context/adminContext";
import ButtonBack from "../../UI/ButtonBack/ButtonBack";

const AddTestCategoryPage = () => {

  const { addCategory } = useContext(AdminContext);
  const [error, setError] = useState(null)
  const [success, setSuccess] = useState(null)
  const [date, setDate] = useState('')
  const [category, setCategory] = useState('')



  const dateHandler = (e) => {
    setDate(e.target.value)
  }
 
  const categoryHandler = (e) => {
    setCategory(e.target.value)
  }

  const submitHandler = (e) => {
    setError(null)
    setSuccess(null)
    e.preventDefault();
    const newDate = new Date(date)
    const transformDate = `${newDate.getFullYear()}-${newDate.getMonth()+1 >= 10 ? newDate.getMonth()+1 : '0' + (newDate.getMonth()+1)}-${newDate.getDate() >= 10 ? newDate.getDate() : '0' + newDate.getDate()}`
    
    addCategory(transformDate, category).then(res => {
      if(res.status === 200)
      {
        setSuccess(res.data)
        setDate('')
        setCategory('')
      } else 
      {
        setError(res.response.data.message)
      }
    })
  }
 
useEffect(()=> {
  document.title = 'Добавить категорию'
}, [])
  return (
    <section className="settings">
        
        
    <div className="container">

        <ButtonBack shortBtn={true}/>
        <h1 className="settings__text">
            Добавление новой категории
        </h1>
            
        <div className="settings__wrapper">

            {error && <p style={{textAlign: 'center', color: 'crimson', fontSize: 20}} >{error}</p>}
          
            {success && <p style={{textAlign: 'center', color: 'darkcyan', fontSize: 20}} >{success}</p>}

            <form  className="settings__form" onSubmit={submitHandler}>
                <div className="settings__item">
                    <label htmlFor="category">Название категории:</label>
                    <input type="text" id="category" name="category" className="settings__input settings__input_middle" value={category} placeholder="Категория" autoComplete="off" required onInput={categoryHandler}/>
                </div>

                <div className="settings__item">
                    <label htmlFor="date">Дата:</label>
                    <input 
                    type="date" 
                    id="date" 
                    name="date" 
                    className="settings__input settings__input_middle" 
                    placeholder="Выберите дату" 
                    value={date} autoComplete="off" 
                    required 
                    onChange={dateHandler}
                    min="2024-01-30"
                    />
                </div>

                <p style={{textAlign: 'justify', marginTop: 20}} >
                   <b> Внимание!</b> Убедитесь, что тестирование по прошлой категории завершно, так как прошлая категория тестов станет не актульной, после добавления новой.
                </p>
                
                
                <button  className="settings__wrapper__link">Добавить</button>
            </form>
            
        </div>
    </div>
</section>

  );
};

export default AddTestCategoryPage;
